var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9817 2.00002C9.30952 2.00483 6.88335 3.05781 5.09214 4.76959L3.65206 3.32951C3.04238 2.71983 2 3.15161 2 4.01378V9.41939C2 9.95386 2.43327 10.3871 2.96774 10.3871H8.37335C9.23552 10.3871 9.6673 9.34475 9.05766 8.73507L7.37419 7.05161C8.61871 5.88632 10.2291 5.24084 11.9399 5.22608C15.6656 5.1939 18.8062 8.20902 18.774 12.0584C18.7434 15.7101 15.7829 18.7742 12 18.7742C10.3417 18.7742 8.77431 18.1824 7.53911 17.0986C7.34786 16.9308 7.05903 16.941 6.87911 17.1209L5.27984 18.7202C5.08339 18.9166 5.0931 19.2369 5.29927 19.4231C7.0725 21.0248 9.42234 22 12 22C17.5228 22 22 17.5229 22 12.0001C22 6.48362 17.4981 1.99015 11.9817 2.00002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.7797d9746f0916ddac1cc13e8c90c350.svg";
export { ForwardRef as ReactComponent };